import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {CLAIM_TYPE_MOTOR, ProductsEnum} from "@ferry/journey-services";
import {FalconNavigatorHeader, resourcesHelper, Footer} from "@ferry/portal-core";
import {Button} from "reactstrap";
import {IWithRouterProps, withRouter} from "@athena-portal/components";

interface IParams {
    policyNumber: string;
    [key: string]: string | undefined
}

interface IState {
    product: string
}

export class WindscreenOrOtherClaimPagePlain extends React.Component<IWithRouterProps<IParams>, IState> {

    constructor(props: IWithRouterProps<IParams>) {
        super(props);
        this.state = {
            product: this.props?.location?.state?.product
        }
    }

    public render() {
        const claim: string = getSessionStorage("claim");
        const isDriveAwayPolicy = this.state.product === ProductsEnum.DRIVE_AWAY
        const phoneNumber = isDriveAwayPolicy ? resourcesHelper.DRIVE_PHONE_NUMBER : resourcesHelper.PHONE_NUMBER;
        const claimTitle = claim === CLAIM_TYPE_MOTOR ? "Windscreen Claim Reporting" : "All other claims"

        return (
            <React.Fragment>
                <FalconHeader/>
                    <div className="page-contents dashboard-page">
                        <FalconNavigatorHeader
                            back={`/dashboard/pickMotorClaimKind/${this.props.params.policyNumber}`}
                            title={claimTitle}
                        />
                        <div className="panel claim-page reset-margins">
                            <div>
                                <img className="claims-icon" src={`/${resourcesHelper.THEME_PATH}/img/make-a-claim.svg`} alt="Make a claim icon"/>
                            </div>
                            <p className="mt-4 mb-4 font-weight-bold text-center">{claim === CLAIM_TYPE_MOTOR ?
                                "To report a windscreen or glass damage get in touch with our recommended windscreen provider." :
                                "For any claims on your car(s) call our 24 hour helpline"}</p>
                            {claim === CLAIM_TYPE_MOTOR &&
                                <div className="windscreen-options">
                                    <div>
                                        <img src="/img/national-windscreens-logo.png" alt="National Windscreens icon"/>
                                    </div>
                                    <Button className="my-2 w-100" color="btn btn-primary btn-next-no-arrow" target="_blank" href="https://www.nationalwindscreens.co.uk/allianzcar">Book an appointment</Button>
                                    <p className="mt-4 mb-4 font-weight-bold text-center">Or call us on our 24 hour helpline and select option 1</p>
                                </div>
                            }
                            <div className="text-center mb-4">
                                <a href={this.toTelHref(phoneNumber || "")} className="mb-4 no-underline font-weight-400 icon-phone-before margin-top-10" id="claimsPagePhoneLink" aria-label={`Phone number ${phoneNumber}`}>{phoneNumber}</a>
                                <p className="font-weight-bold mb-1 mt-3 margin-top-10">From abroad</p>
                                <a href={this.toTelHref(phoneNumber || "")} className="mb-4 no-underline font-weight-400 icon-phone-before margin-top-10" id="claimsPagePhoneLinkAbroad" aria-label={`Phone number (+44) ${phoneNumber}`}>(+44) {phoneNumber}</a>
                            </div>
                            <p className="text-center margin-top-10">Lines open <span className="font-weight-bold">24 hours, 7 days a week.</span>{' '}
                                Calls will be recorded. For Text Phone, first dial 18001
                            </p>
                        </div>
                        <BackButton isTop={false} link={`/dashboard/pickMotorClaimKind/${this.props.params.policyNumber}`}/>
                    </div>
                <Footer/>
            </React.Fragment>
        );
    }

    private toTelHref(raw: string): string {
        const digits = raw.trim()
        return `tel:+44 ${digits}`;
    }
}

export const WindscreenOrOtherClaimPage = withRouter<{}, IParams>(WindscreenOrOtherClaimPagePlain)
